// extracted by mini-css-extract-plugin
export default {"corner_border":"Camra_corner_border__FUIyf","top_right":"Camra_top_right__tnGu3","bottom_left":"Camra_bottom_left__PeZK-","webcam":"Camra_webcam__slNis"};